import { useState } from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Typography from "@mui/material/Typography";
import axios from "axios";

import axiosClient from "../../actions/axiosClient";
import themeKym from "../../utils/themes/ThemeKym";

export default function UploadFileCard(data) {
  const [file, setFile] = useState(null);
  const classesKym = themeKym();
  const classesUploadFile = data.props.classes ? data.props.classes : {};

  function internalOnChange(event) {
    setFile(null);
    data.setFieldValue(data.props.name, event.currentTarget.files[0]);
    saveFile(event.target.files[0]);
  }

  const folderValue = () => {
    if (data.phone) {
      return data.phone;
    }
    return data.msisdn ? data.msisdn : data.idpdv;
  };
  const saveFile = (fileName) => {
    let folder = folderValue();
    let fileExt = fileName.type?.split("/")[1];
    let dataFile = {
      folder: `${folder}`,
      filename: `${data.props.name}.${fileExt}`,
    };
    if (fileExt == "pdf") {
      dataFile.extension = fileExt;
    }
    axiosClient
      .post(`/user/filesUpload`, { ...dataFile })
      .then((uploadResponse) => {
        let url = uploadResponse.data.url;
        let fields = uploadResponse.data.fields;
        let formData = new FormData();
        Object.entries(fields).forEach(([k, v]) => {
          formData.append(k, v);
        });

        formData.append("file", fileName, fileName.name);
        let instance = axios.create({
          headers: {
            post: {
              "Content-Type": "multipart/form-data",
            },
          },
        });
        delete instance.defaults.headers.common["Authorization"];
        instance
          .post(url, formData)
          .then((_) => {
            setFile(fileName);
          })
          .catch((err) => {
            console.log("Error instancia", err);
          });
      })
      .catch((err) => {
        console.log("error upload response", err);
      });
  };

  return (
    <div
      style={{
        padding: "25px 16px",
        marginTop: "15px",
        backgroundColor: "#fff",
        width: "150%",
        height: "70px",
        borderRadius: "4px",
        border: "1px solid #CFD0DF",
        display: "flex",
        flexDirection: "row",
      }}
      className={classesKym[`${classesUploadFile.container}`]}
    >
      <CheckCircleIcon
        style={{
          color: file ? "#66BC6B" : "#CFD0DF",
          fontSize: "20px",
          marginRight: 15,
        }}
      />
      <div style={{ flex: 1 }}>
        <Typography
          variant="h5"
          gutterBottom
          component="div"
          sx={{
            fontWeight: 700,
            fontSize: "12px",
            color: "#343C46",
            float: "left",
          }}
        >
          {data.props?.title}
        </Typography>
      </div>

      <div style={{ position: "relative" }}>
        {!file ? (
          <Typography
            variant="h5"
            gutterBottom
            component="div"
            sx={{
              fontSize: "12px",
            }}
          >
            <a
              style={{
                color: "#363853",
                backgroundColor: "#FABE00",
                padding: "12px",
                textDecoration: "none",
                borderRadius: "4px",
                fontWeight: 700,
              }}
              href="# "
            >
              Subir archivo
            </a>
          </Typography>
        ) : (
          <Typography
            variant="h5"
            gutterBottom
            component="div"
            sx={{
              fontSize: "12px",
            }}
          >
            <a
              style={{
                color: "#363853",
                backgroundColor: "#FFF",
                padding: "12px",
                textDecoration: "none",
                borderRadius: "4px",
                fontWeight: 700,
                border: "1px solid #FABE00",
              }}
              href="# "
            >
              Modificar
            </a>
          </Typography>
        )}
        <input
          data-testid={"InputFile"}
          id="file-id"
          required
          type="file"
          multiple
          accept="image/*,application/pdf"
          style={{
            position: "absolute",
            margin: "0",
            padding: "0",
            width: "110px",
            height: "38px",
            opacity: "0",
            outline: "none",
            cursor: "pointer",
            left: 0,
            top: "-11px",
            background: "red",
          }}
          onChange={internalOnChange}
        />
      </div>
    </div>
  );
}
